module.exports = {
    Lang: {
        de: 'German',
        en: 'English',
        es: 'Spanish',
        fr: 'French',
        pt: 'Portuguese',
        it: 'Italian',
        ru: 'Russian'
    },
    Action: {
        add: 'Add',
        edit: 'Edit',
        remove: 'Remove',
        close: 'Close',
        select: 'Select',
        save: 'Save',
        saving: 'Saving',
        send: 'Send',
        confirmSelection: 'Confirm selection',
        change: 'Change',
        changeSelection: 'Change selection',
        next: 'Next',
        prev: 'Previous',
        finish: 'Finish',
        'search': 'Search'
    },
    Common: {
        start: 'Start',
        date: 'Date',
        creationdate: 'Creation date',
        lastmodified: 'Last modified',
        status: 'Status',
        color: 'Color',
        settings: 'Settings',
        masterdata: 'Master data',
        masterdataSaved: 'Master data saved',
        amount: 'Amount',
        description: 'Description',
        item: 'Item',
        itemNum: 'Item no.',
        itemName: 'Item name',
        itemPrice: 'Item price',
        quantity: 'Quantity',
        singlePrice: 'Sellingprice',
        discount: 'Discount',
        rebate: 'Rebate',
        vat: 'VAT',
        total: 'Total',
        orderPrice: 'Order price',
        annotation: 'Annotation',
        accountDetails: 'Account details',
        customerNum: 'Customer no.',
        salutation: 'Title',
        firstname: 'Firstname',
        lastname: 'Lastname',
        company: 'Company',
        email: 'Email',
        contact: 'Contact',
        address: 'Address',
        postalcode: 'Postalcode',
        city: 'City',
        country: 'Country',
        taxDetails: 'Tax details',
        vatId: 'VAT ID',
        noEntries: 'No entries',
        languageSettings: 'Language settings',
        showXtoYentries: 'Showing {x} to {y} results',
        showXtoYofZentries: 'Showing {x} to {y} out of {z} results',
        errorSavingMasterdata: 'Could not save masterdata.',
        errorIncomplete: 'Incomplete form',
        errorFieldMissing: '{field} is missing',
        errorUploadInvalidResp: 'Invalid server response. Please try again or contact our support.'
    },
    Units: {
        C62: 'pcs.',
        GRM: 'g'
    },
    Dashboard: {
        title: 'Dashboard'
    },
    Addresses: {
        title: 'Addresses',
        add: 'New Address',
        addressMain: 'Main address',
        addressBilling: 'Billing address',
        addressShipping: 'Shipping address',
        confirmRemove: 'Do you really want to remove this address?',
        errorLoad: 'Address could not be loaded.',
        errorRemove: 'Address could not be removed.'
    },
    EditAddress: {
        title: 'New Address',
        errorTypeTitle: 'Please specify an address type.',
        errorTypeText: 'The address must be a billing and/or shipping address.',
        errorCreate: 'Could not create address.',
        errorUpdate: 'Could not update address',
        shipping: 'Shipping',
        useForShippingNo: 'Do not use for shipping',
        useForShippingYes: 'Use as shipping address',
        useForShippingDefault: 'Use as default shipping address',
        billing: 'Billing',
        useForBillingNo: 'Do not use for billing',
        useForBillingYes: 'Use as billing address',
        useForBillingDefault: 'Use as default billing address'
    },
    Projects: {
        title: 'Reports',
        loading: 'Loading reports',
        currentProjects: 'Current reports',
        showAll: 'Show all reports',
        noProjects: 'No reports',
        add: 'Add report',
        projectNumber: 'Report no.',
        projectName: 'Patient ID',
        projectType: 'Report type',
        statusAll: 'All reports',
        statusOpen: 'Open reports',
        statusOrdered: 'Ordered reports',
        errorNoName: 'Please specify a report name.',
        errorCreate: 'Report could not be created.',
        errorCouldNotLoad: 'Could not load report.'
    },
    ProjectDetails: {
        title: 'Order details',
        loading: 'Loading report',
        alertOrdered: 'Report ordered:',
        openOrder: 'Open order',
        alertReference: 'This project references a preceeding project:',
        openProject: 'Open report',
        toothSelection: 'Tooth selection',
        noConstruction: 'No construction',
        editConstruction: 'Edit construction',
        materialSelection: 'Material selection',
        estimatedDelivery: 'Estimated delivery',
        missingMaterial: 'Material selection is missing',
        missingAttachments: 'Missing attachments',
        addStl: 'Add STL',
        openCart: 'Open cart',
        emptyCart: 'Empty cart',
        shippingType: 'Shipping method',
        construction: 'Construction',
        stlUpload: 'STL upload',
        attachments: 'Attachments',
        addons: 'Addons',
        cart: 'Cart',
        addItem: 'Add item',
        orderProject: 'Confirm order',
        statusNotOrdered: 'Not ordered',
        statusOrdered: 'Ordered',
        errorNoProjectnum: 'No valid project number'
    },
    Orders: {
        title: 'Orders',
        loading: 'Loading orders',
        currentOrders: 'Current orders',
        openOrder: 'Open order',
        showAll: 'Show all orders',
        noOrders: 'No orders',
        orderNum: 'Order no.',
        projectRef: 'Project ref.',
        errorCouldNotLoad: 'Could not load order'
    },
    Reports: {
        statusAll: 'All reports',
        statusReceived: 'Data received',
        statusReceivedDescr: 'Processing will start shortly',
        statusInProgress: 'In progress',
        statusInProgressDescr: 'Your order is being processed',
        statusInProduction: 'Report template ready',
        statusInProductionDescr: 'You can download your PDF now',
        statusOnHold: 'On hold',
        statusCancelled: 'Cancelled',
        statusCancelledDescr: 'Your order has been cancelled',
        statusClosed: 'Report generated',
        statusCompleted: 'Report generated',
        statusCompletedDescr: 'Your order has been completed!',
        statusInvoicedCancelled: 'Invoiced / cancelled',
        statusPartlyDelivered: 'Partly delivered',
        statusPartlyDeliveredCancelled: 'Partly delivered / cancelled',
        statusPartlyDeliveredClosed: 'Partly delivered / closed',
        statusDelivered: 'Report generated',
        statusDeliveredDescr: 'Your order has been completed!',
        statusReadyForPickup: 'Ready for pickup',
    },
    OrderDetails: {
        title: 'Order details',
        deliveryNote: 'Delivery note',
        loading: 'Loading order',
        trackingNum: 'Tracking no.',
        manufacturingStatus: 'Manufacturing status',
        trackingAndBilling: 'Tracking and billing',
        creatingOrder: 'Creating order',
        orderProject: 'Confirm order',
        placeOrder: 'Place order',
        acceptTerms: 'I have read and accepted the <a href="{termsUrl}" target="_blank">Terms of Service</a>.',
        errorNoOrderNum: 'Invalid order number',
        errorCouldNotLoad: 'Could not load order',
        priceNobleMetal1: 'The final product price for noble metals is calculated based on the product\'s final weight.',
        priceNobleMetal2: 'Please check your delivery note once you receive the shippment for further details.',
        files: 'Files'
    },
    Messages: {
        title: 'Messages',
        noMessages: 'No messages',
        errorCouldNotLoad: 'Could not load messages',
        writeSomething: 'Write something...',
        errorSendingMessage: 'Error sending message.'
    },
    Configurator: {
        selectIndication: 'Select indication',
        changeMaterial: 'Change material',
        selectTooth: 'Please select a tooth',
        showToothNumbers: 'Show tooth numbers',
        toothSelection: 'Tooth selection',
        setProductProps: 'Set product properties',
        selectProduct: 'Select product',
        fileXofY: 'File {x} of {y}',
        calcPrice: 'Calculating prices',
        uploadStl: 'Upload STL',
        stlCount: 'Unit count for this STL',
        stlCountTooltip: 'Please select the number of units for this STL,',
        oneUnit: 'One unit',
        nUnits: '{n} units',
        removeJawSelection: 'Do you want to remove the product selection for this jaw?',
        invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
        invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
        invalidTeethNumber: 'The {0} is invalid teeth number.',
        transferSettings: 'Do you want to transfer those settings to multiple teeth?',
        clickOnConnectTooth: 'Click on the tooth you want to connect to'
    },
    Invoices: {
        title: 'Invoices',
        loading: 'Loading invoices',
        invoiceNum: 'Invoice no.',
        monthlyStatement: 'Monthly statement',
        statusReceived: 'Received',
        statusOpen: 'Open',
        statusHold: 'On hold',
        statusCancelled: 'Cancelled',
        statusClosed: 'Closed',
        statusPartlyPaid: 'Partly paid',
        statusPartlyPaidCancelled: 'Partly paid / cancelled',
        statusPartlyPaidClosed: 'Partly paid / closed',
        statusPaid: 'Paid'
    },
    File: {
        name: 'File name',
        hash: 'File hash',
        size: 'File size',
        messageUpload: 'Click field or drag/drop file to upload',
        allFilesSameMaterial: 'All files have the same material',
        sendingData: 'Sending data',
        processingData: 'Processing data',
        errorUpload: 'An error occured. Could not upload file.',
        errorCouldNotList: 'Could not load files.',
        errorCouldNotLoad: 'Could not load file.',
        errorCouldNotDelete: 'Could not delete files.'
    },
    Login: {
        username: 'Email or customer number',
        password: 'Password',
        passwordOld: 'Old password',
        passwordNew: 'New password',
        passwordConfirm: 'Confirm new password',
        passwordSaved: 'Password updated',
        login: 'Login',
        logout: 'Logout',
        enterPwd: 'Please enter your password',
        invalidUserOrPwd: 'Invalid username or password',
        errorCouldNotUpdate: 'Could not update password.',
        errorPasswordNoMatch: 'Passwords do not match.',
        errorOldPassword: 'Your old password is wrong.',
        errorNoSession: 'No active user session found. Please log in.'
    }
};
